import { JsonObject, JsonProperty } from 'json2typescript';
import { Attachment } from './attachment';

@JsonObject('LegalDocument')
export class LegalDocument {
  @JsonProperty('id', String)
  public id?: string = undefined;
  @JsonProperty('type', String)
  public type?: string = undefined;
  @JsonProperty('lang', String)
  public lang?: string = undefined;
  @JsonProperty('attachmentId', String, true)
  public attachmentId?: string = undefined;
  @JsonProperty('attachment', Attachment, true)
  public attachment?: Attachment = undefined;
  @JsonProperty('htmlContent', String, true)
  public htmlContent?: string = undefined;
  @JsonProperty('createdDate', String)
  public createdDate?: string = undefined;
  @JsonProperty('modifiedDate', String)
  public modifiedDate?: string = undefined;
}
